import 'tinymce'
import 'tinymce/icons/default/icons.js'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/autoresize/plugin'
import 'tinymce/plugins/emoticons/plugin'
import 'tinymce/plugins/emoticons/js/emojis'
import 'tinymce/plugins/help/plugin'
import 'tinymce/plugins/quickbars/plugin'
import 'tinymce/plugins/noneditable/plugin'
import 'tinymce/plugins/textpattern/plugin'
import 'tinymce/plugins/imagetools/plugin'
import 'tinymce/plugins/wordcount/plugin'
import 'tinymce/plugins/lists/plugin'
import 'tinymce/plugins/advlist/plugin'
import 'tinymce/plugins/insertdatetime/plugin'
import 'tinymce/plugins/toc/plugin'
import 'tinymce/plugins/anchor/plugin'
import 'tinymce/plugins/nonbreaking/plugin'
import 'tinymce/plugins/hr/plugin'
import 'tinymce/plugins/pagebreak/plugin'
import 'tinymce/plugins/charmap/plugin'
import 'tinymce/plugins/table/plugin'
import 'tinymce/plugins/template/plugin'
import 'tinymce/plugins/image/plugin'
import 'tinymce/plugins/codesample/plugin'
import 'tinymce/plugins/media/plugin'
import 'tinymce/plugins/link/plugin'
import 'tinymce/plugins/visualchars/plugin'
import 'tinymce/plugins/visualblocks/plugin'
import 'tinymce/plugins/code/plugin'
import 'tinymce/plugins/autolink/plugin'
import 'tinymce/plugins/directionality/plugin'
import 'tinymce/plugins/save/plugin'
import 'tinymce/plugins/autosave/plugin'
import 'tinymce/plugins/importcss/plugin'
import 'tinymce/plugins/preview/plugin'
import 'tinymce/plugins/print/plugin'
import 'tinymce/plugins/searchreplace/plugin'
import 'tinymce/plugins/paste/plugin'

import 'bootstrap-datepicker';
import moment from 'moment';
import 'daterangepicker';

// require('jszip')(window, $);
import JSZip from 'jszip';
window.JSZip = JSZip;

// import dt from 'datatables.net';
// dt(window, $);
// import('datatables.net/js/jquery.dataTables.js');
require('imports-loader?define=>false!datatables.net')(window, $);
require('imports-loader?define=>false!datatables.net-buttons')(window, $);
require('datatables.net-buttons/js/buttons.html5')(window, $);
require('datatables.net-buttons/js/buttons.print')(window, $);
require('imports-loader?define=>false!datatables.net-buttons-bs4')(window, $);
//

// Import Chart.js to render charts and plugin to work with dates
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';
import { nb } from 'date-fns/locale';

import('./ColReorderWithResize.js');

var defaults = {
  lengthMenu: [10, 25, 50, 100],

  "language": {
    "paginate": {
      "first": '<i class="la la-angle-double-left"></i>',
      "last": '<i class="la la-angle-double-right"></i>',
      "next": '<i class="la la-angle-right"></i>',
      "previous": '<i class="la la-angle-left"></i>'
    }
  }
};

if (KTUtil.isRTL()) {
  defaults = {
    "language": {
      "paginate": {
        "first": '<i class="la la-angle-double-right"></i>',
        "last": '<i class="la la-angle-double-left"></i>',
        "next": '<i class="la la-angle-left"></i>',
        "previous": '<i class="la la-angle-right"></i>'
      }
    }
  }
}

$.extend(true, $.fn.dataTable.defaults, defaults);
$.extend( $.fn.dataTable.ext.classes, {
  sWrapper:      "dataTables_wrapper dt-bootstrap4",
  sFilterInput:  "form-control form-control-sm",
  sLengthSelect: "custom-select custom-select-sm form-control form-control-sm",
  sProcessing:   "dataTables_processing card",
  sPageButton:   "paginate_button page-item"
} );

// fix dropdown overflow inside datatable
KTApp.initAbsoluteDropdown('.dataTables_wrapper');

var Swiper = require('swiper/js/swiper');
var strftime = require('strftime');

import { DirectUpload } from "@rails/activestorage";
// var Dropzone = require('dropzone');
import Dropzone from "dropzone";
Dropzone.autoDiscover = false;

const onDropzoneFileDrop = (event) => {
  var imageUrl = event.dataTransfer.getData('URL');
  var fileName = imageUrl.split('/').pop();

  // set the effectAllowed for the drag item
  event.dataTransfer.effectAllowed = 'copy';

  function getDataUri(url, callback) {
    var image = new Image();

    image.onload = function() {
      var canvas = document.createElement('canvas');
      canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
      canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

      canvas.getContext('2d').drawImage(this, 0, 0);

      // Get raw image data
      // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

      // ... or get as Data URI
      callback(canvas.toDataURL('image/jpeg'));
    };

    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  }

  function dataURItoBlob(dataURI) {
    var byteString,
        mimestring

    if (dataURI.split(',')[0].indexOf('base64') !== -1) {
      byteString = atob(dataURI.split(',')[1])
    } else {
      byteString = decodeURI(dataURI.split(',')[1])
    }

    mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0]

    var content = new Array();
    for (var i = 0; i < byteString.length; i++) {
      content[i] = byteString.charCodeAt(i)
    }

    return new Blob([new Uint8Array(content)], {
      type: mimestring
    });
  }

  getDataUri(imageUrl, function(dataUri) {
    var blob = dataURItoBlob(dataUri);
    blob.name = fileName;
    myDropzone.addFile(blob);
  });
};

function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

class DirectUploadController {
  constructor(dropzone, inputTarget, element, file) {
    this.directUpload = new DirectUpload(file, dropzone.options.url, this);
    this.dropzone = dropzone;
    this.inputTarget = inputTarget;
    this.element = element;
    this.file = file;
  }

  start() {
    this.file.controller = this;
    this.hiddenInput = this.createHiddenInput();
    this.directUpload.create((error, attributes) => {
      if (error) {
        // removeElement(this.hiddenInput);
        this.emitDropzoneError(error);
      } else {
        this.hiddenInput.value = attributes.signed_id;
        this.emitDropzoneSuccess();
      }
    });
  }

  createHiddenInput() {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = this.inputTarget.name;
    insertAfter(input, this.inputTarget);
    return input;
  }

  directUploadWillStoreFileWithXHR(xhr) {
    this.bindProgressEvent(xhr);
    this.emitDropzoneUploading();
  }

  bindProgressEvent(xhr) {
    this.xhr = xhr;
    this.xhr.upload.addEventListener("progress", event =>
      this.uploadRequestDidProgress(event)
    );
  }

  uploadRequestDidProgress(event) {
    const element = this.element;
    const progress = (event.loaded / event.total) * 100;
    findElement(
      this.file.previewTemplate,
      ".dz-upload"
    ).style.width = `${progress}%`;
  }

  emitDropzoneUploading() {
    this.file.status = Dropzone.UPLOADING;
    this.dropzone.emit("processing", this.file);
  }

  emitDropzoneError(error) {
    this.file.status = Dropzone.ERROR;
    this.dropzone.emit("error", this.file, error);
    // this.dropzone.emit("complete", this.file);
  }

  emitDropzoneSuccess() {
    this.file.status = Dropzone.SUCCESS;
    this.dropzone.emit("success", this.file);
    this.dropzone.emit("complete", this.file);
  }
}

// Datepicker
function initDatepicker(selector) {
  $(selector).datepicker({
    format: "dd.mm.yyyy",
    autoclose: true,
  });
}

$(() => {
  $('.select2, .select2-tags').select2({ width: '100%' });

  // var tagSelects = document.getElementsByClassName('select2-tags');
  // if (tagSelects.length) {
  //   Array.from(tagSelects).map(select => {
  //     $(select).select2({ width: '100%' });
  //     // $(select).select2({theme: "classic"});
  //   })
  // }

  // selectpicker
  $('.bootstrap-select').selectpicker();

  // Customer dropzone + ActiveSttorage + upload on submit
  const processingAttribute = 'data-dropzone-durect-upload-processing';
  var dropzoneDirectUploads = document.getElementsByClassName('dropzone-direct-upload'),
      form = document.querySelector('form.simple_form');

  if (dropzoneDirectUploads.length) {
    var onFormSubmit = (event) => {
      if (form.hasAttribute(processingAttribute)) {
        event.preventDefault();
        return
      }

      var source = dropzoneSources.shift();
      if (source === undefined) {
        return
      }

      while (source.dropzone.getAcceptedFiles().length == 0) {
        source = dropzoneSources.shift();
      }

      if (source) {
        event.preventDefault();
        var submitButton = form.querySelector('input[type="submit"], button[type="submit"]');
        submitButton.disabled = true;
        form.setAttribute(processingAttribute, true);

        source.dropzone.getAcceptedFiles().map(file => {
          var uploadController = new DirectUploadController(source.dropzone, source.inputTarget, source.element, file);
          uploadController.start();
        });

        source.dropzone.on('queuecomplete', (event) => {
          form.removeAttribute(processingAttribute);
          // Submit form after all uploads completed
          submitButton.disabled = false;
          submitButton.focus();
          submitButton.click();
          submitButton.disabled = true;
        }).on('error', (event) => submitButton.disabled = false);
      }
    }

    function onMaxFilesExceeded (file) {
      this.removeFile(file);
    }

    function submitForm () {}

    var dropzoneSources =
      Array.from(dropzoneDirectUploads).map(inputTarget => {
        var dropzoneEl = document.querySelector(inputTarget.dataset.target),
            options = inputTarget.dataset;

        var thisDropzone = new Dropzone(options.target, { // Make the whole body a dropzone
            url: options.directUploadUrl, // Set the url for your upload script location
            // parallelUploads: options.parallelUploads || 20,
            // previewTemplate: preview Template,
            maxFiles: options.maxFiles || 1,
            maxFilesize: options.maxFilesize || 100, // Max filesize in MB
            autoQueue: false, // Make sure the files aren't queued until manually added
            // previewsContainer: id + " .dropzone-items", // Define the container to display the previews
            // clickable: id, // + " .dropzone-select" // Define the element that should be used as click trigger to select files.
            acceptedFiles: inputTarget.accept,
            addRemoveLinks: true,
            // maxfilesexceeded: onMaxFilesExceeded,
            init: function() {
              var myDropzone = this;

              this.on("drop", function(event) {
                var imageUrl = event.dataTransfer.getData('URL');
                var fileName = imageUrl.split('/').pop();

                // set the effectAllowed for the drag item
                event.dataTransfer.effectAllowed = 'copy';

                function getDataUri(url, callback) {
                  var image = new Image();

                  image.onload = function() {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                    canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                    canvas.getContext('2d').drawImage(this, 0, 0);

                    // Get raw image data
                    // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

                    // ... or get as Data URI
                    callback(canvas.toDataURL('image/jpeg'));
                  };

                  image.setAttribute('crossOrigin', 'anonymous');
                  image.src = url;
                }

                function dataURItoBlob(dataURI) {
                  var byteString,
                      mimestring

                  if (dataURI.split(',')[0].indexOf('base64') !== -1) {
                    byteString = atob(dataURI.split(',')[1])
                  } else {
                    byteString = decodeURI(dataURI.split(',')[1])
                  }

                  mimestring = dataURI.split(',')[0].split(':')[1].split(';')[0]

                  var content = new Array();
                  for (var i = 0; i < byteString.length; i++) {
                    content[i] = byteString.charCodeAt(i)
                  }

                  return new Blob([new Uint8Array(content)], {
                    type: mimestring
                  });
                }

                getDataUri(imageUrl, function(dataUri) {
                  var blob = dataURItoBlob(dataUri);
                  blob.name = fileName;
                  myDropzone.addFile(blob);
                });
              });
          }
        });
        thisDropzone.on('maxfilesexceeded', onMaxFilesExceeded);
        // thisDropzone.on('drop', onDropzoneFileDrop);

        return {
          dropzone: thisDropzone,
          element: dropzoneEl,
          inputTarget: inputTarget,
        };
      });

    form.addEventListener('submit', onFormSubmit);
  }

  // set the dropzone container id
  // var id = '#startup_images';


  // myDropzone4.on("addedfile", function(file) {
  //     // Hookup the start button
  //     console.log(file);
  //     console.log(myDropzone4.files);
  //     // file.previewElement.querySelector(id + " .dropzone-start").onclick = function() { myDropzone4.enqueueFile(file); };
  //     // $(document).find( id + ' .dropzone-item').css('display', '');
  //     // $( id + " .dropzone-upload, " + id + " .dropzone-remove-all").css('display', 'inline-block');
  // });

  // // Update the total progress bar
  // myDropzone4.on("totaluploadprogress", function(progress) {
  //     $(this).find( id + " .progress-bar").css('width', progress + "%");
  // });

  // myDropzone4.on("sending", function(file) {
  //     // Show the total progress bar when upload starts
  //     $( id + " .progress-bar").css('opacity', '1');
  //     // And disable the start button
  //     file.previewElement.querySelector(id + " .dropzone-start").setAttribute("disabled", "disabled");
  // });

  // // Hide the total progress bar when nothing's uploading anymore
  // myDropzone4.on("complete", function(progress) {
  //     var thisProgressBar = id + " .dz-complete";
  //     setTimeout(function(){
  //         $( thisProgressBar + " .progress-bar, " + thisProgressBar + " .progress, " + thisProgressBar + " .dropzone-start").css('opacity', '0');
  //     }, 300)

  // });

  // Setup the buttons for all transfers
  // document.querySelector( id + " .dropzone-upload").onclick = function() {
  //     myDropzone4.enqueueFiles(myDropzone4.getFilesWithStatus(Dropzone.ADDED));
  // };

  // Setup the button for remove all files
  // document.querySelector(id + " .dropzone-remove-all").onclick = function() {
  //     $( id + " .dropzone-upload, " + id + " .dropzone-remove-all").css('display', 'none');
  //     myDropzone4.removeAllFiles(true);
  // };

  // On all files completed upload
  // myDropzone4.on("queuecomplete", function(progress){
  //     $( id + " .dropzone-upload").css('display', 'none');
  // });

  // On all files removed
  // myDropzone4.on("removedfile", function(file){
  //     if(myDropzone4.files.length < 1){
  //         $( id + " .dropzone-upload, " + id + " .dropzone-remove-all").css('display', 'none');
  //     }
  // });

  // Dropzone.options.reportFilePdfPreview = {
  //   url: null,
  //   acceptedFiles: 'application/pdf'
  // }

  //
  var editableContentId = 'tinymce';

  if (document.getElementsByClassName(editableContentId).length > 0) {
    window.tinymce.init({
      selector: `.${editableContentId}`,
      skin: false,
      content_css: false,
      menubar: 'file edit view insert format tools table tc help',
      toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
      contextmenu: "link image imagetools table",
      plugins: 'autoresize print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
      content_style: "img { max-width: 50%; }",
    });
  }

  // Swiper
  var swiper = new Swiper('.swiper-container', {
    // cssMode: true,
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // pagination: {
    //   el: '.swiper-pagination'
    // },
    // slidesPerView: 2,
    spaceBetween: 10,
    // mousewheel: true,
    keyboard: true,
  });

  // Featured investors slider
  new Swiper('#featured_investors_carousel', {
    // cssMode: true,
    // slidesPerView: 4,
    loop: true,
    // centeredSlides: true,
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
      },
      540: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
    spaceBetween: 20,
    // mousewheel: true,
    keyboard: true,
  });


  // Init plugins for cocoon on ceating new relationship
  ['investment_rounds', 'key_figures', 'funding_rounds', 'admin_remarks'].forEach((sel) => {
    var keyFiguresEl = document.getElementById(sel);
    if (keyFiguresEl) {
      keyFiguresEl.addEventListener('cocoon:after-insert', (e) => {
        $(e.detail.contentNode.querySelector('.select2-tags, .select2')).select2({ width: '100%' });
        initDatepicker($(e.detail.contentNode.querySelector('.portal-datepicker')));
      });
    }
  });

  // Prefill company fields
  ['startup', 'investor', 'company'].forEach((prefix) => {
    const prefillCompanyOnId = `${prefix}_registeret_entity`;
    var prefillCompanyOn = document.getElementById(prefillCompanyOnId);

    if (prefillCompanyOn) {
      const searchButton = prefillCompanyOn.parentElement.querySelector('a.btn');
      searchButton.addEventListener('click', (e) => {
        e.preventDefault();

        fetch(`/search_for_company/${prefillCompanyOn.value}`)
          .then(respJson => {
            if (!respJson.ok) {
              throw Error(respJson.statusText);
            }

            return respJson.json();
          }).then(resp => {
            if (resp.status === 'ok') {
              const result = resp.result;
              document.getElementById(`${prefix}_org_number`).value = result.id;
              document.getElementById(`${prefix}_country`).value = result.country_code;
              document.getElementById(`${prefix}_country`).dispatchEvent(new Event('change'));
              document.getElementById(`${prefix}_city`).value = result.address.city;
              document.getElementById(`${prefix}_postal_code`).value = result.address.postal_code;
              document.getElementById(`${prefix}_address`).value = result.address.street_address;
              document.getElementById(`${prefix}_num_of_employees`) && (document.getElementById(`${prefix}_num_of_employees`).value = result.employees);

              $(document.getElementById(`${prefix}founded_at`)) && ($(document.getElementById(`${prefix}founded_at`)).datepicker('update', new Date(result.founded_at * 1000)));
            }
          }).catch(e => console.error(e))
      })
    }
  })

  initDatepicker('.portal-datepicker');

  // Show on click
  document.querySelectorAll('[data-showable-target]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      document.querySelector(btn.dataset.showableTarget).classList.remove('d-none');
    })
  })

  // Init investors table
  var table = $('#investors'),
      selectedInvestors = new Set();

//   $.fn.dataTable.ext.search.push(
//     function( settings, data, dataIndex ) {
//         var min = parseInt( $('#min').val(), 10 );
//         var max = parseInt( $('#max').val(), 10 );
//         var age = parseFloat( data[3] ) || 0; // use data for the age column

//         if ( ( isNaN( min ) && isNaN( max ) ) ||
//              ( isNaN( min ) && age <= max ) ||
//              ( min <= age   && isNaN( max ) ) ||
//              ( min <= age   && age <= max ) )
//         {
//             return true;
//         }
//         return false;
//     }
// );

  if (table.length) {
    const sendRequestId = 'send_request',
          sendRequestButton = () => document.querySelector(`#${sendRequestId}`);

    // begin first table
    let dTable = table.DataTable({
      responsive: true,
      scrollX: true,

      // DOM Layout settings
      dom: "R<'d-flex' B><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      classes: {
        sFilterInput: 'form-control',
      },

      lengthMenu: [10, 25, 50, 100],

      pageLength: 10,
      pagingType: 'numbers',

      language: {
        'lengthMenu': 'Display _MENU_',
        // 'search': 'Search (name, type, stages, and interests):',
      },

      // Order settings
      order: [[1, 'asc']],

      // headerCallback: function(thead, data, start, end, display) {
      //   thead.getElementsByTagName('th')[0].innerHTML = '\
      //               <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">\
      //                   <input type="checkbox" value="" class="kt-group-checkable">\
      //                   <span></span>\
      //               </label>';
      // },

      buttons: {
        dom: {
            container: {
                tag: 'div',
                className: 'd-flex align-items-end kt-margin-l-10',
            },
            // buttonContainer: {
            //     tag: 'li'
            // },
            button: {
                tag: 'a'
            }
        },
        buttons: [
            // {
            //     text: 'Request introduction',
            //     attr: {
            //       id: sendRequestId,
            //       class: 'btn btn-outline-brand btn-square d-none'
            //     },
            //     action: function ( e, dt, node, config ) {
            //       // alert( idToUrlRequest() );
            //       if (selectedInvestors.size > 14) {
            //         alerrt("You've exceed the limit of 14 investors. Please, remove excess and try again.");
            //       } else {
            //         window.location = `/investors/request_introduction?${idToUrlRequest()}`;
            //       }
            //     }
            // }
        ],
      },

      columnDefs: [
        // {
        //   targets: 0,
        //   width: '30px',
        //   className: 'dt-right',
        //   orderable: false,
        //   render: function(data, type, full, meta) {
        //     return `\
        //                 <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">\
        //                     <input type="checkbox" value="${data}" class="kt-checkable">\
        //                     <span></span>\
        //                 </label>`;
        //   },
        // },
        {
          targets: 4,
          width: '15%',
        },
        // {
        //   targets: 3,
        //   "max-width": '100px',
        // },
        // {
        //   targets: 1,
        //   "min-width": 100,
        // },
        // {
        //   targets: 1,
        //   width: '250px',
        // },
        // {
        //   targets: 1,
        //   render: function(data, type, full, meta) {
        //     return `\
        //             <div style="max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">\
        //                 ${data}\
        //             </div>`;
        //   },
        // },
        {
          targets: [-1, -3],
          // title: 'Actions',
          orderable: false,
          // render: function(data, type, full, meta) {
          //   return '\
          //               <span class="dropdown">\
          //                   <a href="#" class="btn btn-sm btn-clean btn-icon btn-icon-md" data-toggle="dropdown" aria-expanded="true">\
          //                     <i class="la la-ellipsis-h"></i>\
          //                   </a>\
          //                   <div class="dropdown-menu dropdown-menu-right">\
          //                       <a class="dropdown-item" href="#"><i class="la la-edit"></i> Edit Details</a>\
          //                       <a class="dropdown-item" href="#"><i class="la la-leaf"></i> Update Status</a>\
          //                       <a class="dropdown-item" href="#"><i class="la la-print"></i> Generate Report</a>\
          //                   </div>\
          //               </span>\
          //               <a href="#" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="View">\
          //                 <i class="la la-edit"></i>\
          //               </a>';
          // },
        },
        // {
        //   targets: 8,
        //   render: function(data, type, full, meta) {
        //     var status = {
        //       1: {'title': 'Pending', 'class': 'kt-badge--brand'},
        //       2: {'title': 'Delivered', 'class': ' kt-badge--danger'},
        //       3: {'title': 'Canceled', 'class': ' kt-badge--primary'},
        //       4: {'title': 'Success', 'class': ' kt-badge--success'},
        //       5: {'title': 'Info', 'class': ' kt-badge--info'},
        //       6: {'title': 'Danger', 'class': ' kt-badge--danger'},
        //       7: {'title': 'Warning', 'class': ' kt-badge--warning'},
        //     };
        //     if (typeof status[data] === 'undefined') {
        //       return data;
        //     }
        //     return '<span class="kt-badge ' + status[data].class + ' kt-badge--inline kt-badge--pill">' + status[data].title + '</span>';
        //   },
        // },
        // {
        //   targets: 9,
        //   render: function(data, type, full, meta) {
        //     var status = {
        //       1: {'title': 'Online', 'state': 'danger'},
        //       2: {'title': 'Retail', 'state': 'primary'},
        //       3: {'title': 'Direct', 'state': 'success'},
        //     };
        //     if (typeof status[data] === 'undefined') {
        //       return data;
        //     }
        //     return '<span class="kt-badge kt-badge--' + status[data].state + ' kt-badge--dot"></span>&nbsp;' +
        //       '<span class="kt-font-bold kt-font-' + status[data].state + '">' + status[data].title + '</span>';
        //   },
        // },
      ],
    });

    var controlSendButton = () => {
      // console.log(selectedInvestors);

      if (selectedInvestors.size) {
        sendRequestButton().classList.remove('d-none');
      } else {
        sendRequestButton().classList.add('d-none');
      }
    }

    var idToUrlRequest = () => {
      const searchParams = new URLSearchParams;
      selectedInvestors.forEach((val) => searchParams.append('ids[]', val));

      return searchParams.toString();
    }

    // table.on('click', `#${sendRequestId}`, (e) => {
    //   e.preventDefault();
    // })

    table.on('change', '.kt-group-checkable', () => {
      var set = $(this).closest('table').find('td:first-child .kt-checkable');
      var checked = $(this).is(':checked');

      $(set).each(function() {
        $(this).prop('checked', checked);
        if (checked) {
          $(this).closest('tr').addClass('active');
        }
        else {
          $(this).closest('tr').removeClass('active');
        }
      });
    });

    table.on('change', 'tbody tr .kt-checkbox', () => {
      $(this).parents('tr').toggleClass('active');
      var chkbx = $('input', this);
      if (chkbx.is(':checked')) {
        selectedInvestors.add(chkbx.val());
      } else {
        selectedInvestors.delete(chkbx.val());
      }
      controlSendButton();
    });

    // Filtering fields

    $('#dt_search').on( 'keyup', function () {
      dTable.search( this.value ).draw();
    } );

    let investorTypeSelector = $('#dt_investor_type');

    $.fn.dataTable.ext.search.push(
      function( settings, data, dataIndex ) {
        var selectedValues = investorTypeSelector.val();
        var investorType = data[1]; // use data for the age column

        if ( ( selectedValues.length == 0 ) ||
           ( selectedValues.includes(investorType) )
        )
        {
          return true;
        }
        return false;
      }
    );

    investorTypeSelector.on('change', (event) => {
      dTable.draw();
    });

    $(document).on('click', '.investor-type', (event) => {
      // const value = $('#kt_form_category').find(`option:contains("${event.target.textContent}")`).filter(el => ($(el).text() === event.target.textContent) ? true : false }).val();
      const value = investorTypeSelector.find(`option:contains("${event.target.textContent}")`).val();
      investorTypeSelector.val([value]);
      investorTypeSelector.selectpicker('refresh');
      dTable.draw();
    });

    let investorStageSelector = $('#dt_investor_stage');

    $.fn.dataTable.ext.search.push(
      function( settings, data, dataIndex ) {
        var selectedValues = investorStageSelector.val();
        var investorStages = data[2]; // use data for the age column

        if ( ( selectedValues.length == 0 ) ||
           ( selectedValues.filter(value => investorStages.includes(value)).length )
        )
        {
          return true;
        }
        return false;
      }
    );

    investorStageSelector.on('change', (event) => {
      dTable.draw();
    });

    $(document).on('click', '.investor-stage', (event) => {
      // const value = $('#kt_form_category').find(`option:contains("${event.target.textContent}")`).filter(el => ($(el).text() === event.target.textContent) ? true : false }).val();
      const value = investorStageSelector.find(`option:contains("${event.target.textContent}")`).val();
      investorStageSelector.val([value]);
      investorStageSelector.selectpicker('refresh');
      dTable.draw();
    });

    let investorInterestSelector = $('#dt_investor_interesting_category');

    $.fn.dataTable.ext.search.push(
      function( settings, data, dataIndex ) {
        var selectedValues = investorInterestSelector.val();
        var investorInterest = data[3]; // use data for the age column

        if ( ( selectedValues.length == 0 ) ||
           ( selectedValues.filter(value => investorInterest.includes(value)).length )
        )
        {
          return true;
        }
        return false;
      }
    );

    investorInterestSelector.on('change', (event) => {
      dTable.draw();
    });

    $(document).on('click', '.investor-category', (event) => {
      // const value = $('#kt_form_category').find(`option:contains("${event.target.textContent}")`).filter(el => ($(el).text() === event.target.textContent) ? true : false }).val();
      const value = investorInterestSelector.find(`option:contains("${event.target.textContent}")`).val();
      investorInterestSelector.val([value]);
      investorInterestSelector.selectpicker('refresh');
      dTable.draw();
    });
  }

  // Focus Area
  if ($('#focus_areas').length) {
    var datatable = $('#focus_areas').KTDatatable({
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 25, 50, 100],
          }
        }
      },
      data: {
        pageSize: 10,
      },

      search: {
        input: $('#kt_search'),
      },
    });
  }

  // Focus Area
  if ($('#item_recommendations').length) {
    var datatable = $('#item_recommendations').KTDatatable({
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 25, 50, 100],
          }
        }
      },
      data: {
        pageSize: 10,
      },

      search: {
        input: $('#kt_search'),
      },
    });
  }

  // Release notes
  if ($('#release_notes').length) {
    var datatable = $('#release_notes').KTDatatable({
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 25, 50, 100],
          }
        }
      },
      data: {
        pageSize: 10,
      },

      search: {
        input: $('#kt_search'),
      },
      columns: [
        {
          field: 'Year',
          width: 50,
          type: 'number',
          selector: false,
          textAlign: 'center',
        },
        {
          field: 'Document',
          width: 75,
          selector: false,
          textAlign: 'center',
          sortable: false,
        },
      ],
    });
  }

  // Email settings
  if (document.getElementById('admin_email_report_settings')) {
    var datatable = $('#admin_email_report_settings').KTDatatable({
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 25, 50, 100],
          }
        }
      },
      data: {
        pageSize: 10,
      },

      search: {
        input: $('#kt_search'),
      },
    });
  }

  // Industry insights
  if ($('#industry_insights').length) {
    var datatable = $('#industry_insights').KTDatatable({
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 25, 50, 100],
          }
        }
      },
      data: {
        pageSize: 10,
      },

      search: {
        input: $('#kt_search'),
      },
      columns: [
        {
          field: 'Year',
          width: 50,
          type: 'number',
          selector: false,
          textAlign: 'center',
        },
        {
          field: 'Document',
          width: 75,
          selector: false,
          textAlign: 'center',
          sortable: false,
        },
      ],
    });

    $('#kt_form_category').on('change', function() {
      datatable.search($(this).val(), 'Tags');
    });

    $(document).on('click', '.report-file-tag', (event) => {
      // const value = $('#kt_form_category').find(`option:contains("${event.target.textContent}")`).filter(el => ($(el).text() === event.target.textContent) ? true : false }).val();
      const value = $('#kt_form_category').find(`option:contains("${event.target.textContent}")`).val();
      $('#kt_form_category').val([value]);
      $('#kt_form_category').selectpicker('refresh');
      datatable.search(value, 'Tags');
    })
  }

  $('body').on('click', '.search-by-publisher', (event) => {
    event.preventDefault();

    $('#kt_search').val($(event.target).text()).trigger("keyup");
  });

  let newPublisherForm = document.getElementById('new_publisher');

  $('body').on('submit', '#new_publisher', (event) => {
    event.preventDefault();

    let formData = new FormData(newPublisherForm);

    fetch('/publishers', {
      method: 'POST',
      body: formData,
    })
    .then(respJSON => {
      if (!respJSON.ok) {
        throw Error(respJSON.statusText);
        // console.log(respJSON);
      }

      return respJSON.json();
    })
    .then(data => {
      if (data.error_message) {
        throw Error(data.error_message);
      }

      $('input[type="submit"]', newPublisherForm).removeAttr("disabled");

      let selectTag = $(document.getElementById('external_course_publishers') || document.getElementById('startup_file_publishers'));

      if (selectTag.find("option[value='" + data.id + "']").length) {
        selectTag.val(data.id).trigger('change');
      } else {
        // Create a DOM Option and pre-select by default
        var newOption = new Option(data.name, data.id, true, true);
        // Append it to the select
        selectTag.append(newOption).trigger('change');
      }

      newPublisherForm.reset();
      $(newPublisherForm).closest('.modal').modal('hide');
    })
    .catch(error => {
      $('input[type="submit"]', newPublisherForm).removeAttr("disabled");
      // console.log(error);

      alert('Please, check inputs and try again.');
    });
  });

  // Open modals react or AJAX
  $(document).on('click', '[data-toggle="modal"]', (e) => {
    $(`${e.target.dataset.target}`).modal('show');

    return false;
  });

  // Automatically mark all notifications as read
  document.querySelector('#notification_icon') && document.querySelector('#notification_icon').addEventListener('click', (e) => {
    let badgeEl = e.currentTarget.querySelector('.kt-badge');

    if (badgeEl) {
      fetch('/notifications/read_all')
        .then(resp => {
          if (!resp.ok) {
            throw Error(respJson.statusText);
          }

          badgeEl.remove();
        })
    }
  })

  // Administrate profile claim requests
  const claimRequestsTable = $('#claiming_requets');
  if (claimRequestsTable) {
    claimRequestsTable.DataTable({
      responsive: true,
      scrollX: true,

      // DOM Layout settings
      dom: "<'d-flex' f><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      classes: {
        sFilterInput: 'form-control',
      },

      lengthMenu: [10, 25, 50, 100],

      pageLength: 10,
      pagingType: 'numbers',

      language: {
        'lengthMenu': 'Display _MENU_',
      },

      columnDefs: [
        {
          targets: 2,
          orderable: false,
        },
      ],

      // Order settings
      // order: [[1, 'asc']],

      // buttons: {
      //   dom: {
      //       container: {
      //           tag: 'div',
      //           className: 'd-flex align-items-end kt-margin-l-10',
      //       },
      //       button: {
      //           tag: 'a'
      //       }
      //   },
      //   buttons: [
      //       {
      //           text: 'Request introduction',
      //           attr: {
      //             id: sendRequestId,
      //             class: 'btn btn-outline-brand btn-square d-none'
      //           },
      //           action: function ( e, dt, node, config ) {
      //             // alert( idToUrlRequest() );
      //             if (selectedInvestors.size > 14) {
      //               alerrt("You've exceed the limit of 14 investors. Please, remove excess and try again.");
      //             } else {
      //               window.location = `/investors/request_introduction?${idToUrlRequest()}`;
      //             }
      //           }
      //       }
      //   ],
      // },

      // columnDefs: [
      //   {
      //     targets: 0,
      //     width: '30px',
      //     className: 'dt-right',
      //     orderable: false,
      //     render: function(data, type, full, meta) {
      //       return `\
      //                   <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">\
      //                       <input type="checkbox" value="${data}" class="kt-checkable">\
      //                       <span></span>\
      //                   </label>`;
      //     },
      //   },
      //   {
      //     targets: 4,
      //     width: '15%',
      //   },

      //   {
      //     targets: [-1, -3],
      //     orderable: false,

      //   },
      // ],
    });
  }

  const viewMore = document.querySelectorAll('.view-more');
  if (viewMore.length) {
    viewMore.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();

        viewMore.forEach(viewLink => {
          let target = document.querySelector(viewLink.dataset.target);

          target.classList.toggle('d-none');
        })
      })
    });
  }

  const pricingRoleSelects = document.querySelectorAll('#portal_role_select, #cluster_role_select');
  if (pricingRoleSelects.length) {
    pricingRoleSelects.forEach(selectEl => {
      let target = document.querySelector(selectEl.dataset.target);
      target.innerHTML = selectEl.options[selectEl.selectedIndex].dataset.price;
    // });

    // pricingRoleSelects.forEach(selectEl => {
      selectEl.addEventListener('change', event => {
        pricingRoleSelects.forEach(selectEl => {
          $(selectEl).selectpicker('val', event.target.value);
          let target = document.querySelector(selectEl.dataset.target);
          target.innerHTML = selectEl.options[selectEl.selectedIndex].dataset.price;
        });
      })
    })
  }

  // Render statistical charts
  const statCharts = document.querySelectorAll('.cumulativeDataChart');
  if (statCharts) {
    statCharts.forEach(chart => {
      const data = JSON.parse(chart.dataset.data).data;

      new Chart(chart, {
        type: 'line',
        data: {
          datasets: [{
            label: "Total",
            // lineTension: 0.3,
            backgroundColor: "rgba(78, 115, 223, 0.05)",
            borderColor: "rgba(78, 115, 223, 1)",
            pointRadius: 0,
            pointBackgroundColor: "rgba(78, 115, 223, 1)",
            pointBorderColor: "rgba(78, 115, 223, 1)",
            pointHoverRadius: 3,
            pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
            pointHoverBorderColor: "rgba(78, 115, 223, 1)",
            pointHitRadius: 10,
            pointBorderWidth: 2,
            data: data,
            parsing: {
              yAxisKey: 'y.cummulative'
            },
          },
          {
            label: "New",
            lineTension: 0.3,
            backgroundColor: "rgba(78, 115, 223, 0.5)",
            borderColor: "rgba(78, 115, 223, 1)",
            data: data,
            parsing: {
              yAxisKey: 'y.count'
            },

            type: 'bar',
          },
          // {
          //   fill: {
          //     target: 'origin',
          //     below: 'rgba(78, 115, 223, 0.01)',
          //   },
          //   label: "Reference budget",
          //   lineTension: 0.3,
          //   // backgroundColor: "rgba(78, 115, 223, 0.05)",
          //   borderColor: "#EF253D",
          //   borderDash: [15, 15],
          //   pointRadius: 0,
          //   pointBackgroundColor: "#EF253D",
          //   pointBorderColor: "#EF253D",
          //   pointHoverRadius: 3,
          //   pointHoverBackgroundColor: "#EF253D",
          //   pointHoverBorderColor: "#EF253D",
          //   pointHitRadius: 10,
          //   pointBorderWidth: 0,
          //   data: JSON.parse(ctx.dataset.data).budget,
          // }]
          ]
        },
        options: {
          responsive: true,
          aspectRatio: 3,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
                parser: 'dd.MM.yyyy',
                displayFormats: {
                  day: 'MMM yyyy'
                }
              },
              adapters: {
                date: {
                  locale: nb,
                }
              },
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                maxTicksLimit: 7
              }
            },
            y: {
              // beginAtZero: true,
              ticks: {
                maxTicksLimit: 5,
                padding: 10,
                // Include a dollar sign in the ticks
                // callback: function(value, index, values) {
                //   return `${number_format(value)} kr`;
                // }
              },
              grid: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false,
                borderDash: [2],
                zeroLineBorderDash: [2]
              }
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgb(255,255,255)",
              bodyFontColor: "#858796",
              titleColor: '#2E6CC6',
              bodyColor: '#102463',
              titleMarginBottom: 10,
              titleFontColor: '#6e707e',
              titleFontSize: 14,
              borderColor: '#dddfeb',
              borderWidth: 1,
              xPadding: 15,
              yPadding: 15,
              displayColors: false,
              intersect: false,
              mode: 'index',
              caretPadding: 10,
              // callbacks: {
              //   label: (tooltipItem) => {
              //     // const chart = tooltipItem.chart;
              //     // var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
              //     // return datasetLabel + ': $' + number_format(tooltipItem.yLabel);
              //     // return `${tooltipItem.label} : ${number_format(tooltipItem.raw.y)} kr`;
              //     return `${tooltipItem.dataset.label}: ${number_format(tooltipItem.raw.y)} kr`;
              //   }
              // }
            }
          },
        }
      });
    })
  }


  const dataCharts = document.querySelectorAll('.dataChart'),
        renderDataChart = (chart) => {
          const data = JSON.parse(chart.dataset.data).data;
          var chartT = Chart.getChart(chart);
          if (chartT) { chartT.destroy() }

          var chartC = new Chart(chart, {
            type: 'bar',
            data: {
              datasets: [{
                label: "Views",
                lineTension: 0.3,
                backgroundColor: "rgba(78, 115, 223, 0.5)",
                borderColor: "rgba(78, 115, 223, 1)",
                data: data,
                parsing: {
                  yAxisKey: 'y.count'
                },
              }]
            },
            options: {
              // responsive: false,
              // aspectRatio: 3,
              maintainAspectRatio: false,
              animation: false,
              // animation: {
              //   onComplete: () => {
              //     console.log(chartC.toBase64Image());
              //     chart.parentElement.querySelector('img').src = chartC.toBase64Image();
              //   }
              // },
              scales: {
                x: {
                  display: false,

                  suggestedMin: new Date((new Date) - 31 * 24 * 60 * 60 * 1000),
                  suggestedMax: new Date(),
                  // min: new Date((new Date) - 30 * 60 * 1000),

                  type: 'time',
                  time: {
                    unit: 'day',
                    parser: 'dd.MM.yyyy',
                    displayFormats: {
                      day: 'MMM yyyy'
                    }
                  },
                  adapters: {
                    date: {
                      locale: nb,
                    }
                  },
                  grid: {
                    display: false,
                    drawBorder: false
                  },
                  ticks: {
                    maxTicksLimit: 7
                  }
                },
                y: {
                  display: false,
                  // beginAtZero: true,
                  ticks: {
                    maxTicksLimit: 5,
                    padding: 10,
                    // Include a dollar sign in the ticks
                    // callback: function(value, index, values) {
                    //   return `${number_format(value)} kr`;
                    // }
                  },
                  grid: {
                    color: "rgb(234, 236, 244)",
                    zeroLineColor: "rgb(234, 236, 244)",
                    drawBorder: false,
                    borderDash: [2],
                    zeroLineBorderDash: [2]
                  }
                },
              },
              plugins: {
                legend: {
                  display: false,
                },
                tooltip: {
                  // enabled: false,

                  backgroundColor: "rgb(255,255,255)",
                  bodyFontColor: "#858796",
                  titleColor: '#2E6CC6',
                  bodyColor: '#102463',
                  titleMarginBottom: 10,
                  titleFontColor: '#6e707e',
                  titleFontSize: 14,
                  borderColor: '#dddfeb',
                  borderWidth: 1,
                  xPadding: 15,
                  yPadding: 15,
                  displayColors: false,
                  intersect: false,
                  mode: 'index',
                  caretPadding: 10,
                }
              },
            }
          });

          // console.log(chartC.toBase64Image());
          // chart.parentElement.querySelector('img').src = chartC.toBase64Image();
        };
  if (dataCharts) {
    dataCharts.forEach(renderDataChart);
  }

  // Admin activity tables
  ['#company_user_activity_data_table', '#active_profiles_activity_data_table', '#user_activity_data_table'].forEach(id => {
    if ($(id).length) {
      // $(id).addClass('kt-datatable');

      $(id).KTDatatable({
        toolbar: {
          items: {
            pagination: {
              pageSizeSelect: [10, 25, 50, 100],
            }
          }
        },
        data: {
          pageSize: 10,
        },
        search: {
          input: $(id).parent().find('.kt_search'),
        },
        rows: {
          beforeTemplate: (row, data, index) => row.find('.dataChart').length && renderDataChart(row.find('.dataChart')[0]),
        },
        columns: [
          {
            field: 'Latest activity',
            type: 'date',
            format: 'DD.MM.YYYY hh:mm:ss',
          },
          {
            field: 'Login duration',
            type: 'time',
            format: 'hh:mm:ss',
          },
        ]
      });
    }
  });

  const colors = ['#2e6cc6', '#008fdf', '#00adda', '#00c7bc', '#00db90', '#FE701F', '#FF9802', '#F9BE00', '#4EDA79', '#00B5D4'],
        Labels = {
          external_courses: 'Knowledge',
          industry_challenges: 'Industry Challenges',
          report_files: 'Publications',
          fundings: 'Public Funding',
          investors: 'Investors',
          startups: 'Startups',
          startup_files: 'Docs & Tools',
          service_providers: 'Helpers',
        },
        contentCharts = document.querySelectorAll('.contentDataChart');
  if (contentCharts) {
    contentCharts.forEach(chart => {
      const data = JSON.parse(chart.dataset.data).data;

      new Chart(chart, {
        type: 'line',
        data: {
          datasets: Object.entries(data).map((entry, idx) => {
            return {
              pointRadius: 0,
              borderColor: colors[idx],

              // label: I18n.t(entry[0], scope: 'admin.analytics.chart.titles'),
              label: Labels[entry[0]],
              data: entry[1],
              parsing: {
                yAxisKey: 'y.cummulative'
              },
            }
          }),
        },
        options: {
          responsive: true,
          aspectRatio: 3,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
                parser: 'dd.MM.yyyy',
                displayFormats: {
                  day: 'MMM yyyy'
                }
              },
              adapters: {
                date: {
                  locale: nb,
                }
              },
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                maxTicksLimit: 7
              }
            },
            y: {
              // beginAtZero: true,
              ticks: {
                maxTicksLimit: 5,
                padding: 10,
              },
              grid: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false,
                borderDash: [2],
                zeroLineBorderDash: [2]
              }
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgb(255,255,255)",
              bodyFontColor: "#858796",
              titleColor: '#2E6CC6',
              bodyColor: '#102463',
              titleMarginBottom: 10,
              titleFontColor: '#6e707e',
              titleFontSize: 14,
              borderColor: '#dddfeb',
              borderWidth: 1,
              xPadding: 15,
              yPadding: 15,
              displayColors: false,
              intersect: false,
              caretPadding: 10,
            }
          },
        }
      });
    })
  }

  const contentActivityCharts = document.querySelectorAll('.contentActivityChart');
  if (contentActivityCharts) {
    contentActivityCharts.forEach(chart => {
      const data = JSON.parse(chart.dataset.data).data;

      new Chart(chart, {
        type: 'bar',
        data: {
          datasets: Object.entries(data).map((entry, idx) => {
            return {
              pointRadius: 0,
              backgroundColor: colors[idx],

              // label: I18n.t(entry[0], scope: 'admin.analytics.chart.titles'),
              label: Labels[entry[0]],
              data: entry[1],
              parsing: {
                yAxisKey: `y.${entry[0]}.count`
              },
            }
          }),
        },
        options: {
          responsive: true,
          aspectRatio: 3,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'day',
                parser: 'dd.MM.yyyy',
                displayFormats: {
                  day: 'dd. MMM yyyy'
                }
              },
              adapters: {
                date: {
                  locale: nb,
                }
              },
              grid: {
                display: false,
                drawBorder: false
              },
              ticks: {
                maxTicksLimit: 7
              }
            },
            y: {
              // beginAtZero: true,
              ticks: {
                maxTicksLimit: 5,
                padding: 10,
              },
              grid: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false,
                borderDash: [2],
                zeroLineBorderDash: [2]
              }
            },
          },
          plugins: {
            // legend: {
            //   display: false,
            // },
            tooltip: {
              backgroundColor: "rgb(255,255,255)",
              bodyFontColor: "#858796",
              titleColor: '#2E6CC6',
              bodyColor: '#102463',
              titleMarginBottom: 10,
              titleFontColor: '#6e707e',
              titleFontSize: 14,
              borderColor: '#dddfeb',
              borderWidth: 1,
              xPadding: 15,
              yPadding: 15,
              displayColors: false,
              intersect: false,
              caretPadding: 10,
            }
          },
        }
      });
    })
  }

  // const ctx = document.getElementById('cumulativeDataChart');
  // if (ctx) {
  //   new Chart(ctx, {
  //     type: 'line',
  //     data: {
  //       datasets: [{
  //         label: "Total",
  //         // lineTension: 0.3,
  //         backgroundColor: "rgba(78, 115, 223, 0.05)",
  //         borderColor: "rgba(78, 115, 223, 1)",
  //         pointRadius: 0,
  //         pointBackgroundColor: "rgba(78, 115, 223, 1)",
  //         pointBorderColor: "rgba(78, 115, 223, 1)",
  //         pointHoverRadius: 3,
  //         pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
  //         pointHoverBorderColor: "rgba(78, 115, 223, 1)",
  //         pointHitRadius: 10,
  //         pointBorderWidth: 2,
  //         data: JSON.parse(ctx.dataset.data).users,
  //         parsing: {
  //           yAxisKey: 'y.cummulative'
  //         },
  //       },
  //       {
  //         label: "New users",
  //         lineTension: 0.3,
  //         backgroundColor: "rgba(78, 115, 223, 0.5)",
  //         borderColor: "rgba(78, 115, 223, 1)",
  //         // pointRadius: 0,
  //         // pointBackgroundColor: "rgba(78, 115, 223, 1)",
  //         // pointBorderColor: "rgba(78, 115, 223, 1)",
  //         // pointHoverRadius: 3,
  //         // pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
  //         // pointHoverBorderColor: "rgba(78, 115, 223, 1)",
  //         // pointHitRadius: 10,
  //         // pointBorderWidth: 2,
  //         data: JSON.parse(ctx.dataset.data).users,
  //         parsing: {
  //           yAxisKey: 'y.count'
  //         },

  //         type: 'bar',
  //       },
  //       // {
  //       //   fill: {
  //       //     target: 'origin',
  //       //     below: 'rgba(78, 115, 223, 0.01)',
  //       //   },
  //       //   label: "Reference budget",
  //       //   lineTension: 0.3,
  //       //   // backgroundColor: "rgba(78, 115, 223, 0.05)",
  //       //   borderColor: "#EF253D",
  //       //   borderDash: [15, 15],
  //       //   pointRadius: 0,
  //       //   pointBackgroundColor: "#EF253D",
  //       //   pointBorderColor: "#EF253D",
  //       //   pointHoverRadius: 3,
  //       //   pointHoverBackgroundColor: "#EF253D",
  //       //   pointHoverBorderColor: "#EF253D",
  //       //   pointHitRadius: 10,
  //       //   pointBorderWidth: 0,
  //       //   data: JSON.parse(ctx.dataset.data).budget,
  //       // }]
  //       ]
  //     },
  //     options: {
  //       responsive: true,
  //       aspectRatio: 3,
  //       scales: {
  //         x: {
  //           type: 'time',
  //           time: {
  //             unit: 'day',
  //             parser: 'dd.MM.yyyy',
  //             displayFormats: {
  //               day: 'MMM yyyy'
  //             }
  //           },
  //           adapters: {
  //             date: {
  //               locale: nb,
  //             }
  //           },
  //           grid: {
  //             display: false,
  //             drawBorder: false
  //           },
  //           ticks: {
  //             maxTicksLimit: 7
  //           }
  //         },
  //         y: {
  //           // beginAtZero: true,
  //           ticks: {
  //             maxTicksLimit: 5,
  //             padding: 10,
  //             // Include a dollar sign in the ticks
  //             // callback: function(value, index, values) {
  //             //   return `${number_format(value)} kr`;
  //             // }
  //           },
  //           grid: {
  //             color: "rgb(234, 236, 244)",
  //             zeroLineColor: "rgb(234, 236, 244)",
  //             drawBorder: false,
  //             borderDash: [2],
  //             zeroLineBorderDash: [2]
  //           }
  //         },
  //       },
  //       plugins: {
  //         legend: {
  //           display: false,
  //         },
  //         tooltip: {
  //           backgroundColor: "rgb(255,255,255)",
  //           bodyFontColor: "#858796",
  //           titleColor: '#2E6CC6',
  //           bodyColor: '#102463',
  //           titleMarginBottom: 10,
  //           titleFontColor: '#6e707e',
  //           titleFontSize: 14,
  //           borderColor: '#dddfeb',
  //           borderWidth: 1,
  //           xPadding: 15,
  //           yPadding: 15,
  //           displayColors: false,
  //           intersect: false,
  //           mode: 'index',
  //           caretPadding: 10,
  //           // callbacks: {
  //           //   label: (tooltipItem) => {
  //           //     // const chart = tooltipItem.chart;
  //           //     // var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
  //           //     // return datasetLabel + ': $' + number_format(tooltipItem.yLabel);
  //           //     // return `${tooltipItem.label} : ${number_format(tooltipItem.raw.y)} kr`;
  //           //     return `${tooltipItem.dataset.label}: ${number_format(tooltipItem.raw.y)} kr`;
  //           //   }
  //           // }
  //         }
  //       },
  //     }
  //   });
  // }

  const onlineCtx = document.getElementById('onlineUsersChart');
  if (onlineCtx) {
    var plugin = {
      id: 'custom_canvas_background_color',
      beforeDraw: (chart) => {
        const ctx = chart.canvas.getContext('2d');
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#102463';
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    };

    new Chart(onlineCtx, {
      type: 'bar',
      plugins: [plugin],
      data: {
        datasets: [{
          label: "Online users",
          lineTension: 0.3,
          backgroundColor: "white",
          // borderColor: "rgba(78, 115, 223, 1)",
          // pointRadius: 0,
          // pointBackgroundColor: "rgba(78, 115, 223, 1)",
          // pointBorderColor: "rgba(78, 115, 223, 1)",
          // pointHoverRadius: 3,
          // pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
          // pointHoverBorderColor: "rgba(78, 115, 223, 1)",
          // pointHitRadius: 10,
          // pointBorderWidth: 2,
          data: JSON.parse(onlineCtx.dataset.data).users,
          parsing: {
            yAxisKey: 'y.count'
          },

          type: 'bar',
        },
        ]
      },
      options: {
        responsive: true,
        aspectRatio: 2,
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              parser: 'dd.MM.yyyy HH:mm:ss',
              displayFormats: {
                day: 'MMM yyyy'
              }
            },
            suggestedMin: new Date((new Date) - 30 * 60 * 1000),
            min: new Date((new Date) - 30 * 60 * 1000),
            adapters: {
              date: {
                locale: nb,
              }
            },
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              maxTicksLimit: 7
            }
          },
          y: {
            // beginAtZero: true,
            ticks: {
              maxTicksLimit: 5,
              padding: 10,
              // Include a dollar sign in the ticks
              // callback: function(value, index, values) {
              //   return `${number_format(value)} kr`;
              // }
            },
            grid: {
              color: "rgb(234, 236, 244)",
              zeroLineColor: "rgb(234, 236, 244)",
              drawBorder: false,
              borderDash: [2],
              zeroLineBorderDash: [2]
            }
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleColor: '#2E6CC6',
            bodyColor: '#102463',
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: 'index',
            caretPadding: 10,
            // callbacks: {
            //   label: (tooltipItem) => {
            //     // const chart = tooltipItem.chart;
            //     // var datasetLabel = chart.datasets[tooltipItem.datasetIndex].label || '';
            //     // return datasetLabel + ': $' + number_format(tooltipItem.yLabel);
            //     // return `${tooltipItem.label} : ${number_format(tooltipItem.raw.y)} kr`;
            //     return `${tooltipItem.dataset.label}: ${number_format(tooltipItem.raw.y)} kr`;
            //   }
            // }
          }
        },
      }
    });
  }

  let daterangepickerInit = (id) => {
    if ($(id).length == 0) {
      return;
    }

    $(id).on('click', event => event.preventDefault());

    var picker = $(id);
    var url = new URL(window.location);
    var start = parseInt(url.searchParams.get('search[from]')) && moment(parseInt(url.searchParams.get('search[from]'))) || moment().subtract(1, 'month');
    var end = moment(parseInt(url.searchParams.get('search[to]')) || undefined);

    let cb = (start, end, label) => {
      var title = '';
      var range = '';

      if ((end - start) < 100 || label == 'Today') {
          title = 'Today:';
          range = start.format('MMM D');
      } else if (label == 'Yesterday') {
          title = 'Yesterday:';
          range = start.format('MMM D');
      } else {
          range = start.format('MMM D') + ' - ' + end.format('MMM D');
      }

      $('#kt_dashboard_daterangepicker_date').html(range);
      $('#kt_dashboard_daterangepicker_title').html(title);
    }

    picker.daterangepicker({
      direction: KTUtil.isRTL(),
      startDate: start,
      endDate: end,
      maxDate: moment(),
      minDate: moment('20200101'),
      opens: 'left',
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    }, cb);

    picker.on('apply.daterangepicker', (ev, picker) => {
      // console.log(picker.startDate.valueOf(), picker.endDate.valueOf());
      var url = new URL(window.location);
      // Clear params
      url.searchParams.delete('search[from]');
      url.searchParams.delete('search[to]');
      // Update params
      url.searchParams.append('search[from]', picker.startDate.valueOf());
      url.searchParams.append('search[to]', picker.endDate.valueOf());

      window.location = url;
    })

    cb(start, end, '');
  }

  daterangepickerInit('#kt_dashboard_daterangepicker');

  // Detect page close
  // TODO: check "blur" anf "focus" events as well
  window.addEventListener("beforeunload", (e) => {
    let tractionItem = document.querySelector('#activity_traction');

    if (tractionItem) {
      fetch(tractionItem.dataset.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ activity_log: tractionItem.dataset, authenticity_token: document.querySelector('meta[name="csrf-token"]').content }),
      });
    }

    return true;
  });

  // Catching intention changes
  const intentionSelect = document.querySelector('#intention_path');
  if (intentionSelect) {
    intentionSelect.addEventListener('change', (e) => {
      const value = e.target.value;

      window.location = `?path=${value}`;
    });
  }

  // Notificaions / announcements dismissal button
  document.querySelectorAll('[data-dismiss-selector]').forEach(disableButton => {
    disableButton.addEventListener('click', event => {
      var container = document.querySelector(disableButton.dataset.dismissSelector),
          // el = container.querySelector('.kt-portlet__body'),
          el = container,
          hiddenClassName = 'content-hidden',
          displayNoneClassDefault = 'd-none';
      const disabledClass = disableButton.dataset.disabledClass || displayNoneClassDefault;

      if (el.classList.contains(disabledClass)) {
        el.classList.remove(disabledClass);
        container.classList.remove(hiddenClassName);
      } else {
        el.classList.add(disabledClass);
        container.classList.add(hiddenClassName);
      }
    })
  });

  // Custom company notificationss with saved preferences
  const hideEl = (el, className = 'd-none') => el.classList.add(className);
  const showEl = (el, className = 'd-none') => el.classList.remove(className);
  const animateEl = (el, className = 'bounce') => {
    // Clean current animation
    el.classList.remove('fadeOutDown', 'bounceIn', 'fadeInUp', 'bounceOut');

    el.classList.add('animated', className);
  }

  const recommendationsContainer = document.querySelector('#company_recommendation'),
        recommendationsContainerButton = document.querySelector('#show_company_recommendation_button'),
        recommendationsKey = 'showRecommendations';
  if (recommendationsContainer) {
    var showRecommendations = localStorage.getItem(recommendationsKey) == 'true';
    // .animated.bounceInUp
    // data-dismiss-selector="#company_recommendation" data-disabled-class="fadeOutDown"

    if (showRecommendations) {
      showEl(recommendationsContainer);
    } else {
      showEl(recommendationsContainerButton);
    }

    recommendationsContainer.querySelector('button.close').addEventListener('click', event => {
      animateEl(recommendationsContainer, 'fadeOutDown');
      localStorage.setItem(recommendationsKey, false);

      setTimeout(() => {
        showEl(recommendationsContainerButton);
        animateEl(recommendationsContainerButton, 'bounceIn');
      }, 1000);
    });

    recommendationsContainerButton.addEventListener('click', event => {
      animateEl(recommendationsContainerButton, 'bounceOut');
      localStorage.setItem(recommendationsKey, true);

      setTimeout(() => {
        showEl(recommendationsContainer);
        animateEl(recommendationsContainer, 'fadeInUp');
      }, 500);
    });
  }

  document.querySelectorAll('.copy-current-url').forEach(el => {
    el.addEventListener('click', () => {
      if (el.dataset.putTarget) {
        document.querySelector(el.dataset.putTarget).value = window.location;
      } else {
        navigator.clipboard.writeText(el.dataset.copyValue || window.location);
      }
    })
  });

  // Preview item operations
  const previewItem = document.querySelector('#item_preview');
  if (previewItem) {
    setTimeout(() => {
      previewItem.remove();
      window.location = '/';
    }, 1000 * 60 * 5);
  }

  var adminUserTable = $('#admin_users');
  if (adminUserTable.length) {
    // begin first table
    let adminUserDTable = adminUserTable.DataTable({
      responsive: true,
      scrollX: true,

      // DOM Layout settings
      // dom: "R<'d-flex' B><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'<'float-left'B>p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      dom: "R<'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'<'float-left'B>p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      classes: {
        sFilterInput: 'form-control',
      },

      lengthMenu: [10, 25, 50, 100],

      pageLength: 10,
      pagingType: 'numbers',

      language: {
        'lengthMenu': 'Display _MENU_',
      },

      // Order settings
      order: [[1, 'asc']],

      buttons: {
        dom: {
          container: {
              tag: 'div',
              className: 'd-flex align-items-end',
          },
          button: {
              tag: 'a',
              className: 'kt-margin-r-10 btn btn-outline-brand btn-square',
          }
        },
        // buttons: [ 'copy', 'csv', 'print', 'excelHtml5' ],
        buttons: [
          'copy',
          {
            extend: 'excelHtml5',
            exportOptions: {
              columns: [ 0, 1, 2, 3, 4, 5, 6, 7 ]
            }
          },
        ],
      },
      columnDefs: [
        {
          targets: 4,
          width: '15%',
        },
        {
          targets: [-1, -3],
          orderable: false,
        },
      ],
    });

    // Filtering fields
    $('#dt_search').on( 'keyup', function () {
      adminUserDTable.search( this.value ).draw();
    } );
  }

  var userActivityDataTableExcel = $('#user_activity_data_table_excel');
  if (userActivityDataTableExcel.length) {
    // begin first table
    let userActivityDataDTableExcel = userActivityDataTableExcel.DataTable({
      responsive: true,
      scrollX: true,

      // DOM Layout settings
      // dom: "R<'d-flex' B><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'<'float-left'B>p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      dom: "R<'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-7 kt-margin-b-10-tablet-and-mobile'<'float-left'B>p><'col-sm-12 col-md-5'<'float-md-right float-left'l>>>",
      classes: {
        sFilterInput: 'form-control',
      },

      lengthMenu: [10, 25, 50, 100],

      pageLength: 10,
      pagingType: 'numbers',

      language: {
        'lengthMenu': 'Display _MENU_',
      },

      // Order settings
      // order: [[0, 'asc']],

      buttons: {
        dom: {
          container: {
              tag: 'div',
              className: 'd-flex align-items-end',
          },
          button: {
              tag: 'a',
              className: 'kt-margin-r-10 btn btn-outline-brand btn-square',
          }
        },
        // buttons: [ 'copy', 'csv', 'print', 'excelHtml5' ],
        buttons: [
          'copy',
          {
            extend: 'excelHtml5',
            exportOptions: {
              columns: [ 0, 2, 3 ]
            }
          },
        ],
      },
      columnDefs: [
        // {
        //   targets: 4,
        //   width: '15%',
        // },
        {
          targets: [-1],
          orderable: false,
        },
        {
          targets: [1],
          width: "100px"
        },
        // {
        //   targets: [1],
        //   orderable: false,
        //   render: (data, type, row, meta) => row.find('.dataChart').length && renderDataChart(row.find('.dataChart')[0]),
        // },
      ],
    });

    // Filtering fields
    $('.dt_search', userActivityDataTableExcel.closest('.kt-portlet__body')).on( 'keyup', function () {
      userActivityDataDTableExcel.search( this.value ).draw();
    });

    let dataCharts = $('.dataChart', userActivityDataTableExcel).toArray();

    if (dataCharts) {
      dataCharts.forEach(renderDataChart);
    }

    userActivityDataDTableExcel.on( 'draw', function () {
      let dataCharts = $('.dataChart', userActivityDataTableExcel).toArray();

      if (dataCharts) {
        dataCharts.forEach(renderDataChart);
      }
    });
  }
});
